export const sortByString = (a: string, b: string): -1 | 0 | 1 => {
  const nameA = a.toUpperCase();
  const nameB = b.toUpperCase();
  if (nameA < nameB) {
    return -1;
  } else if (nameA > nameB) {
    return 1;
  } else {
    return 0;
  }
};

/**
 * Sorts an array by a key, comparing values as strings.
 * @param array - Array to sort (not mutated)
 * @param key - Property key to sort by
 * @param orderBy - 'asc' for A–Z / ascending, 'desc' for Z–A / descending (default: 'asc')
 */
export const sortByKey = <T>(array: T[], key: keyof T, orderBy: 'asc' | 'desc' = 'asc'): T[] => {
  const sorted = [...array].sort((a, b) => {
    const aVal = String((a[key] as unknown) ?? '');
    const bVal = String((b[key] as unknown) ?? '');
    return sortByString(aVal, bVal);
  });
  return orderBy === 'desc' ? sorted.reverse() : sorted;
};
